import { render, staticRenderFns } from "./VoucherViewForm.vue?vue&type=template&id=4509a660&"
import script from "./VoucherViewForm.vue?vue&type=script&lang=js&"
export * from "./VoucherViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports